import { CookiesKey } from '../cookies/types';

export const refreshTokenCookie: CookiesKey = 'clientspacerefreshtoken';
export const accessTokenCookie: CookiesKey = 'clientspacetoken';